module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/th/3-cc5d71338f4197822a6bb1ea166a57d0.jpg";